module.exports = __webpack_public_path__ + "img/6.da62808f.png";